// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"5ffad77e","977":"1676e8b2"}[chunkId] + ".chunk.js";
};